import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FkIcon } from "./Icons";
import { GROUP_LABEL, PageTitleContext, pageMetaFor } from "./pageMeta";

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "БМ";
  return parts
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}

/** Шапка: бургер (<900), крошка + заголовок, баланс, «В CRM БРАСОЛ», чип компании, аватар. */
export function Topbar({
  menuOpen,
  onToggleMenu,
  balance,
  companyChip,
  avatarText,
  avatarTitle,
}: {
  menuOpen: boolean;
  onToggleMenu: () => void;
  balance?: { label: string | null; to: string } | null;
  companyChip?: string;
  avatarText: string;
  avatarTitle?: string;
}) {
  const { pathname } = useLocation();
  const { override } = useContext(PageTitleContext);
  const meta = pageMetaFor(pathname);
  const crumb = meta.group
    ? `FISHKA Marketing · ${GROUP_LABEL[meta.group]}`
    : "FISHKA Marketing";
  return (
    <header className="fk-topbar">
      <button
        type="button"
        className="fk-burger"
        aria-label={menuOpen ? "Закрыть меню" : "Открыть меню"}
        aria-expanded={menuOpen}
        aria-controls="fk-sidebar"
        onClick={onToggleMenu}
      >
        <FkIcon name="menu" size={20} />
      </button>
      <div className="fk-topbar-title">
        <div className="fk-crumb">{crumb}</div>
        <div className="fk-title">{override ?? meta.title}</div>
      </div>
      {balance && (
        <>
          <Link className="fk-balance" to={balance.to}>
            <FkIcon name="card" size={16} />
            <span>Баланс</span>
            {balance.label !== null && (
              <strong className="fk-mono">{balance.label}</strong>
            )}
          </Link>
          <Link className="fk-balance-icon" to={balance.to} aria-label="Баланс">
            <FkIcon name="card" size={18} />
          </Link>
        </>
      )}
      <a
        className="fk-crm-link"
        href="https://crm.brasol.ru/"
        aria-label="Вернуться в CRM БРАСОЛ"
      >
        <FkIcon name="back" size={14} />
        <span>В CRM БРАСОЛ</span>
      </a>
      {companyChip && (
        <span className="mk-chip fk-company-chip">{companyChip}</span>
      )}
      <span
        className="fk-avatar"
        role="img"
        title={avatarTitle}
        aria-label={
          avatarTitle ? `Пользователь: ${avatarTitle}` : "Пользователь"
        }
      >
        {initials(avatarText)}
      </span>
    </header>
  );
}
